module.exports = __webpack_public_path__ + "img/8_9.76c42f64.png";